import { Step } from '../components/steps/Step';
import { OnboardingFlows } from './common';

export const contentTypeCustomerSuccess: Step = {
    id: OnboardingFlows.UseCases,
    title: 'How do you plan to use D-ID?',
    showCondition: {
        stepId: OnboardingFlows.NewDepartment,
        selectedOption: 'Customer Success',
    },
    multiSelect: false,
    randomize: true,
    options: [
        {
            label: 'Product demo',
        },
        {
            label: 'Sales enablement',
        },
        {
            label: 'Customer onboarding',
        },
        {
            label: 'How-to guide',
        },
        {
            label: 'Product update',
        },
        {
            label: 'Knowledge base',
        },
        {
            label: 'Customer training',
        },
        {
            label: 'Customer comms',
        },
        {
            label: 'Interactive conversational Avatars',
        },
        {
            label: 'AI innovation',
        },
        {
            label: 'Other',
        },
    ],
};
